import {
    AfterContentChecked, AfterViewChecked,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';

import {MyFilterModel} from '../../../../models/my-filter.model';
import {ProjectStatusEnum} from '../../../../enums/project-status.enum';

@Component({
    selector: 'app-project-filter',
    templateUrl: './project-filter.component.html',
    styleUrls: ['./project-filter.component.scss']
})
export class ProjectFilterComponent implements OnChanges {


    @Output() public filterBtnClicked = new EventEmitter<'ACTIVATE_FILTER' | 'RESET_FILTER'>();

    @ViewChild('filterForm', {static: true, read: ElementRef}) filterModal: ElementRef;

    @Input() filterModel: MyFilterModel;
    public projectStatusEnum = ProjectStatusEnum;

    public filterHeight: number;


    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        // this.choices = this.projectsType === 'OPEN' ? [0, 1, 2, 3] : [4, 5];
        this.filterModel.refreshFilterBtnStates();
        this.filterHeight = undefined;
    }

    onSubmit() {
        this.filterBtnClicked.emit('ACTIVATE_FILTER');
    }

    public onResetFilterBtnClicked() {
        this.filterBtnClicked.emit('RESET_FILTER');
    }

    public onFilterCheckboxClicked() {
        this.filterModel.refreshFilterBtnStates();
    }

    public isBottomEdgeVisible(): boolean {

        if (this.filterModal && this.filterModal.nativeElement) {
            const windowHeight = window.innerHeight;
            const rect = this.filterModal.nativeElement.getBoundingClientRect();
            // bottom margin = 70px
            return rect.bottom + 70 < windowHeight;
        }
        return false;
    }


}
